import { Injectable } from '@angular/core';
import {
  IReviewCreatePayload,
  IReviewEditPayload,
  IReviewItem,
  IReviewListResponse,
  IReviewPayload,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { ServiceType } from '../../constants/service-types.enum';
import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class SharedReviewService {
  private readonly _serviceType: ServiceType = ServiceType.DEFAULT;

  constructor(private readonly _httpService: HttpService) {}

  /* ----------------------------- Get all reviews ---------------------------- */
  public getReviews(
    clinicId: number,
    pageNum: number,
    searchText: string
  ): Observable<IReviewListResponse> {
    const apiUrl = API_ENDPOINTS.REVIEWS.getReviews(
      clinicId,
      pageNum,
      searchText
    );

    return this._httpService.get<IReviewListResponse>(
      apiUrl,
      { attachTenantId: true },
      this._serviceType
    );
  }

  /* ----------------------------- Create review ----------------------------- */
  public createReview(
    payload: IReviewCreatePayload,
    clinicId: number
  ): Observable<IReviewItem> {
    const apiUrl = API_ENDPOINTS.REVIEWS.createReview(clinicId);
    return this._httpService.post<IReviewItem, IReviewCreatePayload>(
      apiUrl,
      payload,
      { attachTenantId: true },
      this._serviceType
    );
  }

  /* ----------------------------- Update review ----------------------------- */
  public updateReview(
    payload: IReviewEditPayload,
    clinicId: number
  ): Observable<IReviewItem> {
    const apiUrl = API_ENDPOINTS.REVIEWS.updateReviews(clinicId);
    return this._httpService.post<IReviewItem, IReviewEditPayload>(
      apiUrl,
      payload,
      { attachTenantId: true },
      this._serviceType
    );
  }

  /* ----------------------------- Delete review ----------------------------- */
  public deleteReview(clinicId: number, payload: any): Observable<void> {
    const apiUrl = API_ENDPOINTS.REVIEWS.deleteReview(clinicId);

    return this._httpService.delete<void>(
      apiUrl,
      payload,
      { attachTenantId: true },
      this._serviceType
    );
  }

  /* ----------------------------- Hide/Unhide review ----------------------------- */
  public hideOrUnhideReview(
    clinicId: number,
    payload: IReviewPayload,
    hideValue: boolean
  ): Observable<IReviewItem> {
    const apiUrl = API_ENDPOINTS.REVIEWS.hideOrUnhideReview(
      clinicId,
      hideValue
    );

    return this._httpService.post<IReviewItem, IReviewPayload>(
      apiUrl,
      payload,
      { attachTenantId: true },
      this._serviceType
    );
  }
}
